import React from 'react'
import './Loading.scss'

const Loading = () => (
  <div className="loader">
    <div className="loaderfigure" />
  </div>
)

export default Loading



// WEBPACK FOOTER //
// ./src/modules/Dashboard/Components/Loading/Loading.js